import { Component, Input, Output, EventEmitter } from "@angular/core";

import { LucideAngularModule } from "lucide-angular";
import { MatTooltipModule } from '@angular/material/tooltip';

export interface ButtonDisplayItem {
  id: string;
  icon?: any; // Lucide icon
  iconCondition?: boolean; // Para iconos condicionales (ej: theme toggle)
  alternativeIcon?: any; // Icono alternativo si iconCondition es false
  label?: string; // Texto del botón (opcional para modo compacto)
  action: () => void; // Callback al hacer click
  type?: string; // Tipo de botón para estilos
  ariaLabel?: string; // Para accesibilidad
  showSeparatorAfter?: boolean; // Mostrar separador después de este item
}

@Component({
    selector: "app-button-display",
    standalone: true,
    imports: [LucideAngularModule, MatTooltipModule],
    template: `
    <div 
      [class]="containerClass"
      (click)="$event.stopPropagation()"
    >
      @for (item of items; track item.id) {
        <button 
          (click)="item.action(); onItemClick.emit(item.id)"
          [class]="getButtonClass(item)"
          [matTooltip]="item.ariaLabel ? item.ariaLabel : ''"
          [matTooltipPosition]="'right'"
          [matTooltipShowDelay]="400" 
          [matTooltipHideDelay]="200"
        >
          @if (item.iconCondition !== undefined) {
            <!-- Icono condicional -->
            @if (item.iconCondition) {
              <lucide-angular [img]="item.icon" [class]="iconClass"></lucide-angular>
            } @else {
              <lucide-angular [img]="item.alternativeIcon" [class]="iconClass"></lucide-angular>
            }
          } @else if (item.icon) {
            <!-- Icono simple -->
            <lucide-angular [img]="item.icon" [class]="iconClass"></lucide-angular>
          }
          
          @if (item.label && !isCompact) {
            <span>{{ item.label }}</span>
          }
        </button>
        
        <!-- Separador -->
        @if (item.showSeparatorAfter && !isCompact) {
          <div [class]="separatorClass"></div>
        }
      }
    </div>
    `,
    styles: [],
})

export class ButtonDisplayComponent {
  @Input() items: ButtonDisplayItem[] = [];
  @Input() isCompact: boolean = false; // Modo compacto (solo íconos)
  @Input() containerClass: string = 'user-dropup-menu'; // Clase del contenedor
  @Input() baseButtonClass: string = 'menu-item'; // Clase base de los botones
  @Input() iconClass: string = 'w-4 h-4'; // Clase de los íconos (puede variar según compacto)
  @Input() separatorClass: string = 'h-px border-t border-light-border dark:border-dark-border my-1'; // Clase del separador
  
  @Output() onItemClick = new EventEmitter<string>();
  
  updateThemeButton() {
    const themeItem = this.items.find(item => item.id === 'theme-toggle');
    if (themeItem) {
      themeItem.iconCondition = !themeItem.iconCondition;
      themeItem.label = themeItem.iconCondition ? 'Modo claro' : 'Modo oscuro';
      themeItem.ariaLabel = themeItem.label;
    }
  }

  getButtonClass(item: ButtonDisplayItem): string {
    let classes = this.baseButtonClass;
    
    // Agregar clases para modo compacto
    if (this.isCompact) {
      classes += ' flex items-center justify-center';
    }
    
    // Agregar clase de tipo
    if (item.type !== undefined) {
      classes += ' ' + item.type;
    }
    
    return classes;
  }
}